/**
 * # Search Banner - Text Variations
 */
export interface SearchBannerTextVariation {
    id: number;
    headline: string;
    copyText: string;
}

const SearchBannerTextVariations: SearchBannerTextVariation[] = [
    {
        id: 1,
        headline: 'search-banner-headline-variant-01',
        copyText: 'search-banner-copytext-variant-01',
    },
    {
        id: 2,
        headline: 'search-banner-headline-variant-02',
        copyText: 'search-banner-copytext-variant-02',
    },
    {
        id: 3,
        headline: 'search-banner-headline-variant-03',
        copyText: 'search-banner-copytext-variant-03',
    },
    {
        id: 4,
        headline: 'search-banner-headline-variant-04',
        copyText: 'search-banner-copytext-variant-04',
    },
    {
        id: 5,
        headline: 'search-banner-headline-variant-05',
        copyText: 'search-banner-copytext-variant-05',
    },
];

export default SearchBannerTextVariations;
